'use client';

import { useState } from 'react';
import { clsx } from 'clsx';

import { RadioButtonProps } from './radioButton.types';
import { getRadioChoiceId, getInputGrid } from './radioButton.utils';
import { RadioButtonSurvey } from './components/RadioButtonSurvey';
import { RadioButtonRow } from './components/RadioButtonRow';
import { RadioButtonDefault } from './components/RadioButtonDefault';

function getComponent({ cssClass }: RadioButtonProps) {
  const isCheckboxVariant = cssClass?.includes('is-radio-as-checkbox');

  if (isCheckboxVariant) {
    return RadioButtonRow;
  }

  return RadioButtonDefault;
}

export const RadioButton = (props: RadioButtonProps) => {
  const {
    label,
    choices,
    adminLabel,
    isRequired,
    customId,
    classNames,
    layoutGridColumnSpan = 6,
    cssClass,
    inputVariant,
  } = props;
  // стейт для валидации инпута
  const [isInvalid, setIsInvalid] = useState(false);
  if (!Array.isArray(choices)) return null;

  if (inputVariant === 'meetingSurvey' || inputVariant === 'unsubscribe') {
    return <RadioButtonSurvey {...props} />;
  }

  const isCheckboxVariant = cssClass?.includes('is-radio-as-checkbox');
  const Component = getComponent(props);
  const gridColumn = getInputGrid(layoutGridColumnSpan);

  return (
    <fieldset
      id={customId}
      className={clsx({
        'gf-radio max-w-full': !isCheckboxVariant,
        [gridColumn]: !isCheckboxVariant,
        'col-span-12': isCheckboxVariant,
      })}
    >
      <legend
        className={clsx('text-black-500 mb-2.5 break-words', classNames?.label)}
      >
        {label}
      </legend>

      <div
        className={clsx(
          {
            [classNames?.invalid || 'border-red']:
              isInvalid && !isCheckboxVariant,
            'border-line': !isInvalid && !isCheckboxVariant,
            'flex divide-x border border-line': !isCheckboxVariant,
            'gap-1 lg:gap-3 flex flex-col': isCheckboxVariant,
          },
          classNames?.inputContainer
        )}
      >
        {choices.map((choice) => {
          const id = getRadioChoiceId(adminLabel, choice);
          return (
            <Component
              customId={customId}
              key={`${adminLabel} ${choice?.value}`}
              adminLabel={adminLabel}
              choice={choice}
              id={id}
              isRequired={isRequired}
              setIsInvalid={setIsInvalid}
              classNames={classNames}
            />
          );
        })}
      </div>
    </fieldset>
  );
};
